import React, { useState } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { FiLogOut, FiMenu, FiX, FiSettings, FiActivity, FiUsers } from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import { modulosVisibles, featureFlagEnabled } from '../../config/modulos';
import { SessionProvider } from '../../contexts/SessionContext';
import { useSession } from '../../contexts/SessionContext';
import SessionBar from './SessionBar';
import SesionRouter from './SesionRouter';

// Sub-componente dentro del SessionProvider para acceder a useSession
function LayoutInner({ children }) {
  const { usuario, empresa, logout, empresaActivaId, empresasDisponibles, switchEmpresa } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [abierto, setAbierto] = useState(false);
  const { irInicio } = useSession();

  const ocultarSelectorEmpresa = location.pathname.startsWith('/app/empresas') || location.pathname.startsWith('/app/configuracion') || location.pathname.startsWith('/app/ajustes-empresa');
  const modulos = modulosVisibles(usuario, empresa);

  const onLogout = () => { logout(); navigate('/login'); };
  const nombreCompleto = [usuario?.nombre, usuario?.apellidos].filter(Boolean).join(' ') || usuario?.email;

  const onNavClick = () => { irInicio(); setAbierto(false); };

  return (
    <div className="layout">
      <aside className={`sidebar ${abierto ? 'sidebar--open' : ''}`}>
        <div className="sidebar-header">
          <span className="sidebar-logo">Trix</span>
          <button className="sidebar-close" onClick={() => setAbierto(false)} aria-label="Cerrar menú"><FiX /></button>
        </div>
        <div className="sidebar-empresa">
          {usuario?.rol === 'superadmin' ? 'Superadministrador' : (empresa?.nombre || 'Mi empresa')}
        </div>
        <nav className="sidebar-nav">
          {modulos.map((m) => {
            const Icono = m.icono;
            return (
              <NavLink
                key={m.clave}
                to={m.ruta}
                end={m.clave === 'dashboard'}
                className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
                onClick={onNavClick}
              >
                <Icono />
                <span>{m.nombre}</span>
              </NavLink>
            );
          })}

          <NavLink
            to="/app/comunicados"
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
            onClick={onNavClick}
          >
            <FiActivity />
            <span>Comunicados</span>
          </NavLink>

          {featureFlagEnabled(empresa, 'firma_digital') && (
            <NavLink
              to="/app/documentos-firma"
              className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
              onClick={onNavClick}
            >
              <FiActivity />
              <span>Documentos de firma</span>
            </NavLink>
          )}

          {usuario?.rol === 'admin' && (
            <NavLink
              to="/app/ajustes-empresa"
              className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
              onClick={onNavClick}
            >
              <FiSettings />
              <span>Ajustes de Empresa</span>
            </NavLink>
          )}

          {usuario?.rol === 'superadmin' && (
            <>
              <NavLink
                to="/app/trafico"
                className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
                onClick={onNavClick}
              >
                <FiActivity />
                <span>Tráfico API</span>
              </NavLink>
              <NavLink
                to="/app/empresas"
                className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
                onClick={onNavClick}
              >
                <FiUsers />
                <span>Empresas</span>
              </NavLink>
              <NavLink
                to="/app/configuracion"
                className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
                onClick={onNavClick}
              >
                <FiSettings />
                <span>Ajustes Trix</span>
              </NavLink>
            </>
          )}
        </nav>
        <button className="sidebar-logout" onClick={onLogout}>
          <FiLogOut /><span>Cerrar sesión</span>
        </button>
      </aside>

      <div className="main">
        <header className="topbar">
          <button className="topbar-menu" onClick={() => setAbierto(true)} aria-label="Abrir menú"><FiMenu /></button>
          {!ocultarSelectorEmpresa && empresasDisponibles.length > 1 && (
            <select className="topbar-empresa-select" value={empresaActivaId} onChange={(e) => switchEmpresa(e.target.value)}>
              {empresasDisponibles.map((e) => <option key={e.empresaId} value={e.empresaId}>{e.nombre}</option>)}
            </select>
          )}
          <div className="topbar-user">
            <span className="topbar-name">{nombreCompleto}</span>
            <span className="topbar-rol">{usuario?.rol}</span>
          </div>
        </header>
        <SessionBar />
        <main className="content"><SesionRouter>{children}</SesionRouter></main>
      </div>

      {abierto && <div className="sidebar-overlay" onClick={() => setAbierto(false)} />}
    </div>
  );
}

export default function DashboardLayout({ children }) {
  const { usuario, empresa, empresaActivaId } = useAuth();
  const sessionScopeKey = `${usuario?._id || 'anon'}:${empresa?._id || empresaActivaId || 'none'}`;

  return (
    <SessionProvider key={sessionScopeKey}>
      <LayoutInner>{children}</LayoutInner>
    </SessionProvider>
  );
}
